<div class="d-flex align-items-center justify-content-end">
    <wdx-icon
        [class.invisible]="!data?.isMine"
        icon="user-tie"
        icon="lock"
        iconStyle="fas"
    ></wdx-icon>

    @if (data?.avatar) {
        <molecule-avatar
            class="ms-2"
            size="sm"
            data-cy="action-button-cell-avatar"
            [avatar]="data?.avatar"
        ></molecule-avatar>
    }

    @if (!data?.hideFavourite) {
        <wdx-toggle-button
            class="ms-2"
            size="sm"
            data-cy="action-button-cell-favourite"
            [toggle]="data?.isFavourite"
            (wdxOnChange)="onToggleChange($event)"
        ></wdx-toggle-button>
    }

    <molecule-action-button
        class="ms-2"
        data-cy="action-button-cell-action-menu"
        [actionButton]="data?.contextMenu"
        (selectMenuItem)="onMenuItemSelected($event)"
    ></molecule-action-button>
</div>
